var exports = {
  "modalBackdrop": "Modal.module__modalBackdrop___OWRFQ1",
  "layer": "Modal.module__layer___OWRFQ1",
  "backdropSlot": "Modal.module__backdropSlot___OWRFQ1",
  "positionAbsoluteInsetZero": "Modal.module__positionAbsoluteInsetZero___OWRFQ1",
  "backdropCentered": "Modal.module__backdropCentered___OWRFQ1",
  "focusLock": "Modal.module__focusLock___OWRFQ1",
  "surface": "Modal.module__surface___OWRFQ1",
  "layerFullscreen": "Modal.module__layerFullscreen___OWRFQ1",
  "layerFullscreenMobile": "Modal.module__layerFullscreenMobile___OWRFQ1",
  "layerCentered": "Modal.module__layerCentered___OWRFQ1",
  "root": "Modal.module__root___OWRFQ1",
  "centeredOnMobile": "Modal.module__centeredOnMobile___OWRFQ1",
  "rootAnimating": "Modal.module__rootAnimating___OWRFQ1",
  "medium": "Modal.module__medium___OWRFQ1",
  "small": "Modal.module__small___OWRFQ1",
  "footer": "Modal.module__footer___OWRFQ1",
  "formFooter": "Modal.module__formFooter___OWRFQ1",
  "large": "Modal.module__large___OWRFQ1",
  "xlarge": "Modal.module__xlarge___OWRFQ1",
  "fullscreen": "Modal.module__fullscreen___OWRFQ1",
  "layout": "Modal.module__layout___OWRFQ1",
  "header": "Modal.module__header___OWRFQ1",
  "light": "Modal.module__light___OWRFQ1",
  "dark": "Modal.module__dark___OWRFQ1",
  "stretchButtons": "Modal.module__stretchButtons___OWRFQ1",
  "headerInner": "Modal.module__headerInner___OWRFQ1",
  "headerText": "Modal.module__headerText___OWRFQ1",
  "content": "Modal.module__content___OWRFQ1",
  "contentNoPadding": "Modal.module__contentNoPadding___OWRFQ1",
  "screenReaderLabel": "Modal.module__screenReaderLabel___OWRFQ1",
  "insetCloseButtonContainer": "Modal.module__insetCloseButtonContainer___OWRFQ1",
  "insetCloseButton": "Modal.module__insetCloseButton___OWRFQ1",
  "contentLayout": "Modal.module__contentLayout___OWRFQ1",
  "description": "Modal.module__description___OWRFQ1",
  "inputGroup": "Modal.module__inputGroup___OWRFQ1",
};

__webpack_require__.r(module.exports = exports);
